{
    "SCOPEASSIGNMENT_CME": "ECM:",
    "SCOPEASSIGNMENT_FilterRecursively": "Filtrare in modo ricorsivo:",
    "SCOPEASSIGNMENT_TelServer": "Server di telefonia:",
    "SCOPEASSIGNMENT_Partition": "Partizione:",
    "NAME": "ScopeAssignment"
}